import React from 'react'
import './footer.scss'

function Footer({className=""}) {
  return (
    <div className={ `${className}`}>
        <div className='text_footer'>
          <div className='text_footer_name_section' dir='rtl'>
          <span dir='rtl'>   تصميم و برمجة م. صالح الحايك و  م.عماد زرز  </span>
          <span dir='rtl'> من قسم التقانة لمجموعة المتين  </span>
          </div>

           <span><a href="#">Almatin.com</a>&copy; { new Date().getFullYear() }</span>
        </div>
    </div>
  )
}

export default Footer
